import React from 'react';
import { Section } from '../ui/Section';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function Identification() {
  const points = ['Te levantás cansada antes de empezar el día', 'Vas a trabajar o estudiar con la energía justa', 'Llegás a casa sin fuerzas para nada más', 'Todo lo hacés, pero todo pesa el doble', 'Vivís funcionando, no disfrutando'];
  return <Section background="light-purple" containerSize="md" className="text-center" data-id="element-155">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} data-id="element-156">
        <h2 className="text-3xl md:text-5xl font-black text-slate-900 mb-6" data-id="element-157">
          Si vivís así, no es casualidad
        </h2>

        <div className="prose prose-lg mx-auto text-slate-700 mb-10" data-id="element-158">
          <p className="text-xl" data-id="element-159">
            Tenés entre 25 y 40 años. Tu vida no está mal. Pero está pesada.
          </p>
          <p className="text-xl mt-4" data-id="element-160">
            Trabajás. Estudiás o te capacitás. Sostenés una casa, vínculos y
            responsabilidades.
          </p>
          <p className="text-xl font-bold text-fuchsia-700 mt-4" data-id="element-161">
            Y aunque cumplís con todo, por dentro estás agotada.
          </p>
        </div>

        <div className="space-y-4 max-w-2xl mx-auto text-left" data-id="element-162">
          {points.map((point, index) => <motion.div key={index} className="bg-white p-5 rounded-xl border border-purple-200 shadow-sm flex items-start gap-4" initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: index * 0.1
        }} viewport={{
          once: true
        }} whileHover={{
          scale: 1.02
        }} data-id="element-163">
              <div className="bg-purple-100 p-1.5 rounded-full flex-shrink-0 mt-0.5" data-id="element-164">
                <Check className="w-4 h-4 text-purple-600" strokeWidth={3} data-id="element-165" />
              </div>
              <p className="text-lg font-medium text-slate-800" data-id="element-166">{point}</p>
            </motion.div>)}
        </div>
      </motion.div>
    </Section>;
}